import axios from 'axios'
import { debounce, includes, isArray } from 'lodash'
import { events } from '@main/js/bus'
import Vue from 'vue'

const defaultState = {
  authorized: undefined,
  permission: 'master', // master | editor | visitor
  user: undefined,
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
}

const actions = {
  getAppData: ({ commit, getters }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(getters.api + '/user' + getters.sorting.URI)
        .then((response) => {
          resolve(response)

          // Redirect user if is logged
          if (router.currentRoute.name === 'SignIn')
            router.push({ name: 'Files' })

          commit('RETRIEVE_USER', response.data)
        })
        .catch((error) => {
          reject(error)

          // Redirect if unauthenticated
          if ([401, 403].includes(error.response.status)) {
            commit('SET_AUTHORIZED', false)
            //router.push({name: 'SignIn'})
          }
        })
    })
  },
}

const mutations = {
  RETRIEVE_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, token) {
    localStorage.setItem('token', token)
    state.token = token
  },
}

const getters = {
  permission: (state) => state.permission,
  isGuest: (state) => !state.authorized,
  isLogged: (state) => state.authorized,
  user: (state) => state.user,
  token: (state) => state.token,
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
}
